import { getUrl } from './api'
import { getReq } from './appService'

// 获取排序列表
export const getStakesRanks = (chainId: number, params: any, cb: any) => {
  const url = getUrl('/v1/stakes/ranks', chainId, params)
  getReq(url, cb)
}

export const getBakeInfo = (chainId: number, cb: any) => {
  const url = getUrl('/v1/bake-info', chainId)
  getReq(url, cb)
}

// 获取首页数据
export const getSummary = (chainId: number, cb: any) => {
  const url = getUrl('/v1/bakery/summary', chainId)
  getReq(url, cb)
}

export const getVotesSummary = (chainId: number, params: any, cb: any) => {
  const url = getUrl('/v1/nfts/votes/summary', chainId, params)
  getReq(url, cb)
}